import clsx from "clsx";

const Pagination = ({ activeIndex = 0, swiper }) => (
  <div
    className={clsx("pagination_wrapper", {
      white_text: [2, 3, 9, 10].includes(activeIndex),
    })}
  >
    <div className="pagination">
      <button
        type="button"
        className={clsx("bullet", {
          active: activeIndex === 0,
        })}
        onClick={() => swiper?.slideTo(0)}
      >
        <span className="bullet_text">Cover</span>
      </button>
      <button
        type="button"
        className={clsx("bullet", {
          active: activeIndex === 1,
        })}
        onClick={() => swiper?.slideTo(1)}
      >
        <span className="bullet_text">Introduction</span>
      </button>
      <button
        type="button"
        className={clsx("bullet", {
          active: activeIndex >= 2,
        })}
        onClick={() => swiper?.slideTo(2)}
      >
        <span className="bullet_text">Application</span>
      </button>
    </div>
  </div>
);

export default Pagination;
